module.exports = __webpack_public_path__ + "img/brand-white.31270c6e.svg";